// One foreground refresh per return to the window (CYBORG-1205 item 2). Coming back
// fires `visibilitychange` AND `focus` within milliseconds, and each ran the whole
// foreground path: statuses, unread and every open agent timeline were read twice.
// A trigger within `windowMs` of the last run joins it; `force` (network `online`) never does.

export function foregroundOnce(
  run: () => Promise<void>,
  windowMs: number,
  now: () => number = Date.now,
): (opts?: { force?: boolean }) => Promise<void> {
  let lastStart = Number.NEGATIVE_INFINITY;
  return async (opts) => {
    const t = now();
    if (!opts?.force && t - lastStart < windowMs) return;
    lastStart = t;
    await run();
  };
}
